import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../../composant/layout/AdminSidebar/AdminSidebar";
import "./AdminLayout.css";

export default function AdminLayout() {
  return (
    <div className="admin-layout">
      <aside className="admin-layout-sidebar">
        <AdminSidebar />
      </aside>

      <main className="admin-layout-content">
        <Outlet />
      </main>
    </div>
  );
}